module.exports = __webpack_public_path__ + "static/slide3-17a6f57d54f47e008d262adaefe34b23.webp";